define([
    "jquery",
    "underscore",
    "marionette",
    "views/withdrawal/common_view",
    "forms/withdrawal/skrill_form"
], function($, _, Marionette, CommonView, SkrillForm) {
    return CommonView.extend({
        initialize: function(){
            this.bindUIElements();
            this.form = new SkrillForm();

            if(window.form_error)
            {
                this.triggerMethod('show:errors', window.form_error);
                window.form_error = null;
            }
        }
    });
});
